import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getInformations, Information } from '../../api/informations';
import type { RootState } from '../store';
import type { AsyncStatus } from '../../interfaces';

interface InformationsState {
  status: AsyncStatus;
  list: Information[];
}

const initialState: InformationsState = { status: 'idle', list: [] };

export const fetchInformations = createAsyncThunk(
  'informations/fetchAll',
  () => getInformations(),
  // Skip only if a fetch is already in progress (prevents concurrent duplicate requests).
  { condition: (_, { getState }) => (getState() as RootState).informations.status !== 'loading' },
);

const informationsSlice = createSlice({
  name: 'informations',
  initialState,
  reducers: {
    // Reset state so the next mount triggers a fresh fetch.
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInformations.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchInformations.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload;
      })
      .addCase(fetchInformations.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { reset: resetInformations } = informationsSlice.actions;
export default informationsSlice.reducer;
